import * as yup from 'yup';
import cardValidator from 'card-validator';

const acceptedCardTypes = ['visa', 'mastercard', 'american-express', 'discover'];
const today = new Date();

export const validationSchema = yup.object().shape({
    firstName: yup
        .string()
        .required('First name is required')
        .matches(/^(?![-\s]*$)[A-Za-z\s-]+$/, 'Only letters, spaces, and hyphens, and must include at least one letter'),
    lastName: yup
        .string()
        .required('Last name is required')
        .matches(/^(?![-\s]*$)[A-Za-z\s-]+$/, 'Only letters, spaces, and hyphens, and must include at least one letter'),
    cardNumber: yup
        .string()
        .required('Card number is required')
        .test('is-valid-card', 'Invalid card number', function (value) {
            return cardValidator.number(value).isValid && acceptedCardTypes.includes(cardValidator.number(value).card.type);
        }),
    expirationDate: yup
        .string()
        .required('Expiration date is required')
        .test('is-valid-format', 'Expiration date must be in the format MM/YY', function (value) {
            if (!/^\d{2}\/\d{2}$/.test(value)) {
                return false;
            }

            const [month, _] = value.split('/');
            const monthNumber = parseInt(month, 10);

            return monthNumber >= 0 && monthNumber <= 12;
        })
        .test('is-not-in-past', 'Expiration date must not be in the past', function (value) {
            const [month, year] = value.split('/').map(str => parseInt(str, 10));
            if (!month || !year) {
                return false;
            }
            const fullYear = 2000 + parseInt(year.toString(), 10);
            const expirationDate = new Date(fullYear, month - 1);
            return expirationDate > today;
        }),
    cvv: yup
        .string()
        .required('CVV is required')
        .test('is-valid-cvc', 'Invalid CVC', value => cardValidator.cvv(value, 3).isValid || cardValidator.cvv(value, 4).isValid),
    hasDifferentBillingAddress: yup.number().required().oneOf([1, 2], 'Invalid option for hasDifferentBillingAddress'),
    billingDetails: yup.object().when('hasDifferentBillingAddress', {
        is: 2,
        then: schema =>
            schema.shape({
                addressLine1: yup.string().required('Address is required'),
                city: yup.string().required('City is required'),
                state: yup.string().required('State is required'),
                zip: yup.string().test('len', 'Please enter a valid zip code', val => val?.toString().length === 5)
            }),
        otherwise: schema => schema
    })
});

export const preferredSchema = yup.object({
    preferred: yup.boolean().oneOf([true], 'Please set payment method as preferred')
});
